export default {
  // Thanh điều hướng bên (Navigation Sidebar)
  navigation: {
    home: 'Trang chủ',
    gameCenter: 'Trung tâm trò chơi',
    rechargeCenter: 'Trung tâm nạp tiền',
    imChat: 'Trò chuyện IM',
    consult: 'Tin tức Sao Ngộ', // 'StalConsult' được dịch là 'Tin tức Sao Ngộ' dựa trên ngữ cảnh '星遇咨讯'
  },

  // Trang chủ
  home: {
    platformFeatures: 'Tính năng nền tảng',
    quickActionsName: 'Thao tác nhanh',
    footerText: 'Làm cho livestream đơn giản hơn và tương tác thú vị hơn',
    features: {
      gameCenter: {
        title: 'Trung tâm trò chơi',
        description: 'Tài nguyên trò chơi phong phú hỗ trợ phát trực tiếp đa nền tảng',
      },
      imChat: {
        title: 'Nhắn tin tức thời',
        description: 'Tương tác trò chuyện thời gian thực để nâng cao trải nghiệm người xem',
      },
      dataAnalysis: {
        title: 'Phân tích dữ liệu',
        description: 'Thống kê chi tiết để tối ưu hóa hiệu suất phát trực tiếp',
      },
      efficientStable: {
        title: 'Hiệu quả & Ổn định',
        description: 'Trải nghiệm phát trực tiếp mượt mà với dịch vụ đáng tin cậy',
      },
    },
    stats: {
      activeUsers: 'Người dùng hoạt động',
      gameResources: 'Tài nguyên trò chơi',
      serviceAvailability: 'Khả dụng dịch vụ',
      technicalSupport: 'Hỗ trợ kỹ thuật',
    },
    quickActions: {
      gameCenter: 'Trung tâm trò chơi',
      imChat: 'Trò chuyện IM',
      consult: 'Tư vấn',
    },
  },

  // Trung tâm trò chơi (Game Center)
  gameCenter: {
    language: 'Tiếng Việt', // Thay '简体中文' thành 'Tiếng Việt' cho giao diện tiếng Việt
    balance: 'Số dư',
    hotGames: 'Game đang hot',
    download: 'Tải xuống',
    update: 'Cập nhật',
    startTikTok: 'Bắt đầu livestream',
    startBigo: 'Bắt đầu livestream',
    document: 'Tài liệu',
    currentGame: 'Trò chơi đang livestream:',
    currentStatus: 'Trạng thái livestream hiện tại:',
    recharge: 'Nạp tiền',
    restart: 'Khởi động lại công cụ và trò chơi',
    closeLive: 'Tắt livestream',
    downloadProgress: 'Tiến trình tải xuống:',
    decompProgress: 'Tiến trình giải nén:',
    waitDecomp: 'Chờ giải nén',
    fixBug: 'Sửa lỗi (Fix bug)',
    clickUpdate: 'Nhấn để cập nhật (Click update)',
    downloading:
      'Đang tải xuống, vui lòng kiên nhẫn đợi ~ (Please wait patiently while downloading ~)',
    pay: 'Đang thanh toán...',
    xzf: 'Cần thanh toán',
    zs: 'Kim cương',
    dest: 'Plugin chống chặn trò chơi Danmu',
    getff: 'Mở khóa Plugin',
    ffbtun: 'Phát sóng đánh giá chống máy móc',
    qrkb: 'Xác nhận livestream',
    tkl: 'Bạn đã sẵn sàng để bắt đầu đánh giá và phát sóng chống máy móc chưa?',
    qd: 'Xác nhận',
    qx: 'Hủy',
  },

  // Trò chuyện IM (IM Chat)
  imChat: {
    search: 'Tìm kiếm',
    searchNoResult: 'Không tìm thấy người dùng này',
    tryOtherKeywords: 'Vui lòng thử từ khóa tìm kiếm khác',
    noConversations: 'Chưa có lịch sử trò chuyện',
    startChatting: 'Tìm kiếm người dùng để bắt đầu trò chuyện',
    loadingConversations: 'Đang tải danh sách cuộc trò chuyện...',
    connecting: 'Đang kết nối đến máy chủ trò chuyện...',
    connectionFailed: '⚠️ Kết nối thất bại, tính năng trò chuyện tạm thời không khả dụng',
    checkNetwork: 'Vui lòng kiểm tra kết nối mạng hoặc liên hệ CSKH',
    selectUser: 'Vui lòng chọn một người dùng để bắt đầu trò chuyện',
    sending: 'Đang gửi...',
    sendMessage: 'Gửi',
    enterMessage: 'Vui lòng nhập tin nhắn...',
    noMessages: 'Chưa có tin nhắn',
    welcomeChat: 'Chào mừng bạn đến với tính năng trò chuyện',
    selectConversationHint: 'Vui lòng chọn một cuộc trò chuyện từ bên trái để bắt đầu',
    inputDisabledDisconnected:
      'Kết nối đã bị ngắt. Trò chuyện tạm thời không khả dụng. Các chức năng khác vẫn bình thường. Vui lòng đăng nhập lại để khôi phục chức năng trò chuyện.',
    inputDisabledOfficialNotification: 'Thông báo chính thức chỉ để nhận, bạn không thể trả lời',
    RecentSessions: 'Các phiên gần đây',
    RecommendedChat: 'Bạn bè toàn cầu',
    Online: 'Online',
    Offline: 'Offline',
  },

  // Tin tức (Consult - StalConsult)
  StalConsult: {
    // Giữ nguyên key, chỉ dịch value
    search2: 'Tìm kiếm',
    all: 'Tất cả',
    Payment: 'Thanh toán',
    ViewFullContent: 'Xem toàn bộ nội dung',
    UnlockFullContent: 'Mở khóa toàn bộ nội dung',
    NeedToPay: 'Cần thanh toán',
    diamond: 'kim cương',
    CurrentBalance: 'Số dư hiện tại',
    Cancel: 'Hủy',
    PayNow: 'Thanh toán ngay',
    InsufficientBalance: 'Số dư không đủ',
    loading: 'Đang tải...',
    NoMoreContent: 'Không còn nội dung nào nữa',
    return: 'trở lại',
    fd: 'Phóng to để xem',
  },

  // Thông báo chung (Common Prompts)
  common: {
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    save: 'Lưu',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    loading: 'Đang tải...',
    success: 'Thành công',
    failed: 'Thất bại',
    error: 'Lỗi',
    warning: 'Cảnh báo',
    info: 'Thông tin',
  },
}
